<div class="l-main__contents">
  <div class="c-notification">
    <ul class="c-notification__list">
      <div *ngIf="personalNotificationList.length !== 0">
        <li *ngFor="let notification of personalNotificationList" class="c-notification__item">
          <a (click)="notificationLink(notification.link)" style="cursor: pointer"
            ><i class="c-icon__attention_fill"></i>
            <p>{{ notification.title }}</p>
            <p *ngIf="notification.count !== 0">
              <b>{{ notification.count }}件</b>あります。
            </p>
            <i class="c-icon__arrow_s_right"></i>
          </a>
        </li>
      </div>
    </ul>

    <ul class="c-overall_notification_list">
      <ng-container *ngIf="overAllNotificationList.length !== 0">
        <li *ngFor="let notification of overAllNotificationList" class="c-overall_notification_item">
          <a (click)="notificationLink(notification.descriptionLink)" style="cursor: pointer">
            <div class="text_item">
              <div class="date">{{ notification.releaseDatetime }}</div>
              <div class="text">{{ notification.description }}</div>
            </div>
          </a>
        </li>
      </ng-container>
    </ul>
  </div>

  <div class="c-service-list">
    <h2 class="c-notification__title"><i class="c-icon-service"></i>サービス一覧</h2>
    <ul class="c-service-list__list">
      <li
        class="c-service-list__item"
        *ngFor="let launcher of launchers"
        [class.c-service-list__item--disable]="!launcher.isUser || !launcher.isRelease"
      >
        <p class="c-service-list__box">
          <a
            (click)="serviceLink(launcher)"
            ActionTransaction
            [commandCd]="viewCd + '-clickMenu-' + launcher.serviceCd | removePeriod"
            ><img [src]="getLauncherLogo(launcher)" [class.-garage]="launcher.serviceCd === 'core.p-garage'" alt=""
          /></a>
        </p>
        <div *ngIf="launcher.isUser && !launcher.isRelease" class="p-dashboard-display__description_service_top">
          <p style="text-align: center">準備中</p>
        </div>
        <!-- <p class="c-service-list__link"><a href="#">サービス紹介サイトへ</a></p> -->
      </li>
    </ul>
  </div>

  <div class="c-petabo-notification">
    <h2 class="c-notification__title"><i class="c-icon-hint"></i>お知らせ</h2>
    <div class="c-petabo-notification__buttons">
      <!-- 重要なお知らせがある場合はこちらのボタンを表示 -->
      <button
        *ngIf="!!notificationData?.notificationDivision"
        class="c-petabo-notification__button"
        [class.c-petabo-notification__button--edit]="notificationData?.notificationDivision === '1'"
        [class.c-petabo-notification__button--system-alart]="notificationData?.notificationDivision === '2'"
        (click)="navigateToImportantNotice()"
        ActionTransaction
        [commandCd]="actionTransactionCommandCd"
      >
        <img
          [src]="
            notificationData?.notificationDivision === '1'
              ? 'assets/images/petabo-infomation/icon-important70o.gif'
              : 'assets/images/petabo-infomation/icon-failure70.gif'
          "
          class="c-icon-notification"
        />
        <span class="button-title">
          {{ notificationData?.buttonTitle }}
        </span>
        <span class="button-description">
          {{ notificationData?.buttonText }}
        </span>
      </button>

      <!-- 重要なお知らせがない場合はこちらのボタンを表示 -->
      <button
        *ngIf="enableIdeaBtn"
        class="c-petabo-notification__button c-petabo-notification__button--idea"
        (click)="navigateToIdea()"
        ActionTransaction
        [commandCd]="viewCd + '-clickPetabo-idea-button'"
      >
        <img
          src="assets/images/petabo-infomation/icon-ideaplace70.gif"
          alt=""
          class="c-icon-notification"
          style="margin-bottom: 0rem"
        />
        <img src="assets/images/petabo-infomation/idealogo.png" alt="イデアプラス" class="button-title-image" />
        <span class="button-description">サービス・サポート情報発信サイト</span>
      </button>

      <button
        class="c-petabo-notification__button c-petabo-notification__button--info"
        (click)="navigateToPetaboInformation()"
        ActionTransaction
        [commandCd]="viewCd + '-clickPetabo-information-button'"
      >
        <img src="assets/images/petabo-infomation/icon-info70.gif" alt="" class="c-icon-notification" />
        <span class="button-title">お知らせ</span>
        <span class="button-description">インターサーブからのお知らせ</span>
      </button>

      <button
        class="c-petabo-notification__button c-petabo-notification__button--video"
        (click)="navigateToPetaboVideo()"
        ActionTransaction
        [commandCd]="viewCd + '-clickPetabo-video-button'"
      >
        <img src="assets/images/petabo-infomation/icon-movie70.gif" alt="" class="c-icon-notification" />
        <span class="button-title">動画コンテンツ</span>
        <span class="button-description">ちょっと困った！を解決する動画のご紹介</span>
      </button>
    </div>
  </div>
</div>

<!-- 重要なお知らせポップアップ -->
<app-important-notice-popup #noticePopup [viewCd]="popupActionTransactionViewCd"></app-important-notice-popup>

